import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  header: {
    id: 'report.basicInfo.header',
    description: 'Basic info header',
    defaultMessage: 'Perustiedot',
  },
  companyMunicipalitiesLabel: {
    id: 'report.basicInfo.companyMunicipalities',
    description: 'Company municipalities',
    defaultMessage: 'Toimialueet',
  },
  companyMunicipalitiesLabelWholeCountryFi: {
    id: 'report.basicInfo.companyMunicipalitiesLabelWholeCountryFi',
    description: 'Whole Finland',
    defaultMessage: 'Koko Suomi',
  },
  companyMunicipalitiesLabelHometown: {
    id: 'report.basicInfo.companyMunicipalitiesLabelHometown',
    description: 'Hometown',
    defaultMessage: 'Kotikaupunki',
  },
  companyKeywordsLabel: {
    id: 'report.basicInfo.companyKeywords',
    description: 'Company keywords',
    defaultMessage: 'Hakusanat',
  },
  marketingName: {
    id: 'report.summary.marketingName',
    description: 'Marketing name',
    defaultMessage: 'Yrityksen antama markkinointinimi',
  },
  industry: {
    id: 'report.summary.industry',
    description: 'Industry',
    defaultMessage: 'Toimiala',
  },
  readMore: {
    id: 'report.summary.readMore',
    description: 'Read more',
    defaultMessage: 'Lue lisää',
  },
  readLess: {
    id: 'report.summary.readLess',
    description: 'Read less',
    defaultMessage: 'Pienennä',
  },
  marketingNamePlaceholder: {
    id: 'report.summary.marketingNamePlaceholder',
    description: 'Marketing name placeholder',
    defaultMessage: 'markkinointinimi',
  },
  marketingNameLabel: {
    id: 'report.summary.marketingNameLabel',
    description: 'Marketing name label',
    defaultMessage: 'Markkinointinimi',
  },
  primaryNameLabel: {
    id: 'report.summary.primaryNameLabel',
    description: 'Primary name label',
    defaultMessage: 'Viralliset nimet',
  },
  alternativeNamesLabel: {
    id: 'report.summary.alternativeNamesLabel',
    description: 'Alternative names label',
    defaultMessage: 'Aputoiminimet',
  },
  marketingNameInfo: {
    id: 'report.summary.marketingNameInfo',
    description: 'Marketing name info',
    defaultMessage: 'Markkinointinimi on yrityksen vapaasti valittava epävirallinen nimi, joka näytetään ensisijaisena nimenä Zeckit-sivustolla.',
  },
  primaryNameInfo: {
    id: 'report.summary.primaryNameInfo',
    description: 'Primary name info',
    defaultMessage: 'Yrityksen virallista yritysrekisterissä olevaa ensisijaista nimeä tai aputoiminimiä ei voi muokata vapaasti.',
  },
  alternativeNamesInfo: {
    id: 'report.summary.alternativeNamesInfo',
    description: 'Alternative names info',
    defaultMessage: 'Yrityksellä voi olla useita vapaavalintaisia aputoiminimiä, jotka voivat olla esimerkiksi entisiä nimiä tai vaihtoehtoisia kirjoitusasuja.',
  },
  bankrupt: {
    id: 'report.summary.bankrupt',
    description: 'Bankrupt explanation',
    defaultMessage: `<h3 class='first-level-header'>Varoitus</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on lakannut, koska se on konkurssissa ja kyvytön hoitamaan vastuitaan. Ostaessasi konkurssiyritykseltä menetät todennäköisesti maksamasi rahat ja ostamasi palvelut jäävät saamatta.</p>
                     <p class={hiddenDetails}>Konkurssilla tarkoitetaan sitä, ettei velallinen kykene suorittamaan velkojaan ja vastuitaan. Konkurssia voi hakea velkojat tai yritys itse. Yritys asetetaan konkurssiin aina tuomioistuimen toimesta ja siitä tehdään merkintä konkurssirekisteriin, kaupparekisteriin ja luottotietorekistereihin, jonka lisäksi siitä tiedotetaan julkisesti.</p>
                     <p class={hiddenDetails}>Konkurssi voidaan myös peruuttaa velallisen ja velkojan yhteisestä hakemuksesta.</p>`,
  },
  ceased: {
    id: 'report.summary.ceased',
    description: 'Ceased explanation',
    defaultMessage: `<h3 class='first-level-header'>Varoitus</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on lakannut.</p>`,
  },
  businessBan: {
    id: 'report.summary.businessBan',
    description: 'Business ban explanation',
    defaultMessage: `<h3 class='first-level-header'>Varoitus</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen vastuuhenkilö on tuomittu talousrikoksesta ja on liiketoimintakiellossa. Ostaessasi liiketoimintakiellossa olevalta yritykseltä otat riskin.</p>
                     <p class={hiddenDetails}>Liiketoimintakielto määrätään aina tuomioistuimen toimesta ja siitä tehdään merkintä liiketoimintakieltorekisteriin, kaupparekisteriin ja luottotietorekistereihin, jonka lisäksi siitä tiedotetaan julkisesti. Liiketoimintakielto on voimassa vain Suomessa ja liiketoimintakieltoon määrätty henkilö voi harjoittaa toimintaa muualla EU:ssa.</p>
                     <p class={hiddenDetails}>Liiketoimintakielto on määräaikainen ja se voidaan rajata koskemaan vain tietyn tyyppistä yritystoimintaa.</p>`,
  },
  luotettavaKumppani: {
    id: 'report.summary.luotettavaKumppani',
    description: 'Luotettava kumppani expalanation',
    defaultMessage: `<h3 class='first-level-header'>Luotettava Kumppani</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on läpinäkyvää, koska se on antanut luvan tarkastaa laajasti omat tietonsa, esimerkiksi vero- ja työeläketiedot, Luotettava Kumppani  -ohjelmassa. Tietojen perusteella yritys on hoitanut velvoitteensa hyvin.</p>
                     <p class={hiddenDetails}>Tiedot voidaan tarkastaa, koska yritys on mukana Luotettava Kumppani -ohjelmassa.</p>
                     <p class={hiddenDetails}>Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvioinnit.</p>`,
  },
  luotettavaKumppaniRegistry: {
    id: 'report.summary.luotettavaKumppaniRegistry',
    description: 'Luotettava kumppani registry explanation',
    defaultMessage: `<h3 class='first-level-header'>Luotettava Kumppani</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen toiminta on läpinäkyvää, koska se on antanut luvan tarkastaa laajasti omat tietonsa, esimerkiksi vero- ja työeläketiedot, Luotettava Kumppani –ohjelmassa. Tietojen perusteella yritys on hoitanut velvoitteensa hyvin.</p>
                     <p class={hiddenDetails}>Yrityksen ei tarvitse kuulua kaikkiin rekistereihin, jos toiminta on pientä, eikä sillä ole esimerkiksi useita vakituisia työntekijöitä.</p>
                     <p class={hiddenDetails}></Tiedot voidaan tarkastaa, koska yritys on mukana Luotettava Kumppani -ohjelmassa. Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvoinnit.p>`,
  },
  warningResponsibilities: {
    id: 'report.summary.warningResponsibilities',
    description: 'Warning responsibilities explanation',
    defaultMessage: `<h3 class='first-level-header'>Käytä harkintaa</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan voit tehdä huoletta arvoltaan pieniä ostoksia. Suuremmat hankinnat kannattaa maksaa pienissä erissä ja välttää hankintoja, joissa takuun merkitys on suuri.</p>
                     <p class={hiddenDetails}>Yritys ei kuitenkaan ole hoitanut kaikkia vastuitaan ajallaan. Hoidettavia vastuita ovat esimerkiksi yrityksen verot ja työntekijöiden eläkkeet.</p>
                     <p class={hiddenDetails}>Merkintä tulee yritykselle, jolla on verovelkaa tai muita yritysvastuuseen kuuluvia hoitamattomia maksuja. Tiedot saadaan tarkastettua ainoastaan Luotettava Kumppani-ohjelmassa mukana olevilta yrityksiltä. Merkintä tulee, jos työeläkemaksut on laiminlyöty tai veroja on maksamatta yli 10 000 euroa.</p>`,
  },
  warningCreditNotice: {
    id: 'report.summary.warningCreditNotice',
    description: 'Warning credit notice explanation',
    defaultMessage: `<h3 class='first-level-header'>Käytä harkintaa</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan voit tehdä huoletta arvoltaan pieniä ostoksia. Suuremmat hankinnat kannattaa maksaa pienissä erissä ja välttää hankintoja, joissa takuun merkitys on suuri.</p>
                     <p class={hiddenDetails}>Yritys ei kuitenkaan ole hoitanut kaikkia vastuitaan ajallaan. Hoidettavia vastuita ovat esimerkiksi yrityksen verot ja työntekijöiden eläkkeet. Maksuhäiriömerkintä syntyy riidattomasta saatavasta yksipuolisen tuomion perusteella tai saatava on laissa määritelty suoraan ulosottokelpoiseksi.</p>
                     <p class={hiddenDetails}>Merkintä tulee yritykselle, jolla on verovelkaa tai muita yritysvastuuseen kuuluvia hoitamattomia maksuja. Tiedot saadaan tarkastettua ainoastaan Luotettava Kumppani-ohjelmassa mukana olevilta yrityksiltä. Merkintä tulee, jos työeläkemaksut on laiminlyöty tai veroja on maksamatta yli 10 000 euroa.</p>`,
  },
  ok: {
    id: 'report.summary.ok',
    description: 'Ok',
    defaultMessage: `<h3 class='first-level-header'>Perustiedot kunnossa</h3>
                     <p>Zeckit-palvelun tietolähteiden mukaan yrityksen perustiedot ovat kunnossa ja toiminta vaikuttaa normaalilta. Vero- ja työeläkemaksutietoja ei kuitenkaan voida tarkastaa, koska yritys ei ole mukana <a href='https://www.tilaajavastuu.fi/fi/luotettava-kumppani/'>Luotettava Kumppani –ohjelmassa</a>. <strong>Tarkasta aina verovelat <a href='https://www.ytj.fi/'>YTJ -yrityshausta</a>.</strong></p>
                     <p class={hiddenDetails}>YTJ -yrityshaussa näytetään yli 10.000 euron verovelat.</p>
                     <p class={hiddenDetails}>Suuremmissa hankinnoissa kannattaa kuitenkin aina pyytää myös referenssit ja katsoa yrityksen saamat arvioinnit.</p>
                     <p class={hiddenDetails}>Selvitys on suppea, koska yrityksen Luotettava Kumppani –raporttia ei ole mahdollista tarkistaa, koska yritys ei kuulu Luotettava Kumppani –ohjelmaan.</p>`,
  },
  unknown: {
    id: 'report.summary.unknown',
    description: 'Unknown explanation',
    defaultMessage: 'Tuntematon ensimmäisen tason tulkinta: {firstLevel}',
  },
  facebookShareTitle: {
    id: 'report.summary.facebookShareTitle',
    description: 'Title for post shared in Facebook',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  facebookShareDescription: {
    id: 'report.summary.facebookShareDescription',
    description: 'Description for post shared in Facebook',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  twitterShareTitle: {
    id: 'report.summary.twitterShareTitle',
    description: 'Title for post shared in Twitter',
    defaultMessage: 'Katsoin juuri Zeckit-selvityksen, katso sinäkin!',
  },
  // EDIT MODE
  taxPrepaymentActive: {
    id: 'report.summary.taxPrepaymentActive',
    description: 'According to our info a tax prepayment is possible but you can change the info using button below',
    defaultMessage: 'Tietojemme mukaan yrityksesi tekemästä työstä saa kotitalousvähennyksen. Voit kuitenkin määrittää tiedon itse alla olevasta napista.',
  },
  taxPrepaymentInactive: {
    id: 'report.summary.taxPrepaymentInactive',
    description: 'According to our info a tax prepayment is not possible but you can change the info using button below',
    defaultMessage: 'Tietojemme mukaan yrityksesi tekemästä työstä ei saa kotitalousvähennyksen. Voit kuitenkin määrittää tiedon itse alla olevasta napista.',
  },
  taxPrepaymentDisable: {
    id: 'report.summary.taxPrepaymentDisable',
    description: 'Click here to disable tax prepayment',
    defaultMessage: 'Klikkaa tästä, jos yrityksesi ei tarjoa kotitalousvähennystä',
  },
  taxPrepaymentEnable: {
    id: 'report.summary.taxPrepaymentEnable',
    description: 'Click here to enable tax prepayment',
    defaultMessage: 'Klikkaa tästä, jos yrityksesi tarjoaa kotitalousvähennyksen',
  },
  expandList: {
    id: 'report.summary.expandList',
    description: 'Click to expand list',
    defaultMessage: 'Näytä kaikki',
  },
  contractList: {
    id: 'report.summary.contractList',
    description: 'Click to contract list',
    defaultMessage: 'Näytä vähemmän',
  },
  checkoutBrochure: {
    id: 'portfolio.badge.callToActionButton',
    description: 'Call to action button for company brochure',
    defaultMessage: 'Katso esite',
  }
});
